<template>
	<div :class="{ webview }">
        <CloHeading v-if="webview" level="1" size="3" class="u-stack-md">{{ $t('license.agreement') }}</CloHeading>
        <p class="u-text-1 u-text-muted" v-html="$t('license.agreement.note', placeholders)"></p>
        <CloHeading level="2" size="5" class="u-stack-md">{{ $t('license.agreement.title', placeholders) }}</CloHeading>
        <p class="u-text-2" v-html="$t('license.agreement.desc', placeholders)"></p>
        <CloHeading level="3" size="5" class="u-stack-md">{{ $t('license.agreement.i.title') }}</CloHeading>
        <p class="u-text-2"><strong>{{ $t('license.agreement.i.desc1') }}</strong></p>
        <p class="u-text-2" v-html="$t('license.agreement.i.desc2', placeholders)"></p>
        <p class="u-text-2">{{ $t('license.agreement.i.desc3', placeholders) }}</p>
        <p class="u-text-2" v-html="$t('license.agreement.i.desc4', placeholders)"></p>
        <CloHeading level="3" size="5" class="u-stack-md">{{ $t('license.agreement.ii.title') }}</CloHeading>
        <p class="u-text-2">{{ $t('license.agreement.ii.desc1', placeholders) }}</p>
        <CloHeading level="3" size="5" class="u-stack-md">{{ $t('license.agreement.iii.title') }}</CloHeading>
        <p class="u-text-2">{{ $t('license.agreement.iii.desc1') }}</p>
        <p class="u-text-2"><strong>{{ $t('license.agreement.iii.desc2') }}</strong></p>
        <p class="u-text-2" v-html="$t('license.agreement.iii.desc3', placeholders)"></p>
        <p class="u-text-2"><strong>{{ $t('license.agreement.iii.desc4') }}</strong></p>
        <p class="u-text-2">{{ $t('license.agreement.iii.desc5', placeholders) }}</p>
        <p class="u-text-2">{{ $t('license.agreement.iii.desc6', placeholders) }}</p>
        <p class="u-text-2">{{ $t('license.agreement.iii.desc7') }}</p>
	</div>
</template>

<script>
import axios from 'axios';
import CloHeading from '@/base/CloHeading/CloHeading.vue';

export default {
	components: {
		CloHeading
	},
    props: {
        webview: {
            type: Boolean,
            default: false
        }
    },
	data() {
		return {
            placeholders: {
                'CornellLabOfOrnithology': 'Cornell Lab of Ornithology',
                'CornellLab': 'Cornell Lab',
                'eBird': 'eBird',
                'Merlin': 'Merlin',
                'MacaulayLibrary': 'Macaulay Library',
                'BirdsOfTheWorld': 'Birds of the World',
                'CornellUniversity': 'Cornell University',
                'guidelinesLink': '<a href="https://support.ebird.org/support/solutions/articles/48001257989" target="_blank" rel="noopener noreferrer">',
                'termsLink': '<a href="https://www.birds.cornell.edu/home/terms-of-use/" target="_blank" rel="noopener noreferrer">',
                'endLink': '</a>',
                'prefsLink': '<a href="https://ebird.org/prefs" target="_blank" rel="noopener noreferrer">',
                'startBold': '<strong>',
                'endBold': '</strong>',
                'ticketLink': '<a href="https://support.ebird.org/support/tickets/new" target="_blank" rel="noopener noreferrer">',
                'eBirdEmailAddress': 'eBird@cornell.edu',
                'englishLink': '<a href="https://support.ebird.org/en/support/solutions/articles/48000952192" target="_blank" rel="noopener noreferrer">',
            },
		};
	},
};
</script>

<style lang="scss" scoped>
$default-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
.webview {
    font-family: $default-font-family;
    @include inset-responsive;
    max-width: 768px;
    margin: 0 auto;
    .Heading {
        font-weight: 500;
    }
}
.u-text-muted {
    color: $color-text-muted;
}
</style>
